import { render, staticRenderFns } from "./PlantillasCalendario.vue?vue&type=template&id=3635a25b&scoped=true"
import script from "./PlantillasCalendario.vue?vue&type=script&lang=js"
export * from "./PlantillasCalendario.vue?vue&type=script&lang=js"
import style0 from "./PlantillasCalendario.vue?vue&type=style&index=0&id=3635a25b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3635a25b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VAutocomplete,VBtn,VIcon,VProgressLinear,VSnackbar})
